export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validatePassword = (password) => {
    const passwordRegex = /(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}/;
    return passwordRegex.test(password);
};